export const API_ENDPOINTS = {
  profiles: {
    all: "/profiles",
    detail: (slug: string) => `/profiles/${slug}`,
    publicDetail: (publicId: string) => `/profiles/public/${publicId}`,
    photos: (slug: string) => `/profiles/${slug}/photos`,
    services: (slug: string) => `/profiles/${slug}/services`,
    products: (slug: string) => `/profiles/${slug}/products`,
    posts: (slug: string) => `/profiles/${slug}/posts`,
    comments: (slug: string) => `/profiles/${slug}/comments`,
    view: (slug: string) => `/profiles/${slug}/view`,
    whatsappClick: (slug: string) => `/profiles/${slug}/click/whatsapp`,
    telegramClick: (slug: string) => `/profiles/${slug}/click/telegram`,
  },

  services: {
    all: "/services",
    detail: (slug: string) => `/services/${slug}`,
    profiles: (slug: string) => `/services/${slug}/profiles`,
  },

  products: {
    all: "/products",
    detail: (slug: string) => `/products/${slug}`,
    photos: (slug: string) => `/products/${slug}/photos`,
    view: (slug: string) => `/products/${slug}/view`,
    whatsappClick: (slug: string) => `/products/${slug}/click/whatsapp`,
    telegramClick: (slug: string) => `/products/${slug}/click/telegram`,
  },

  categories: {
    all: "/categories",
    detail: (slug: string) => `/categories/${slug}`,
    profiles: (slug: string) => `/categories/${slug}/profiles`,
    services: (slug: string) => `/categories/${slug}/services`,
    products: (slug: string) => `/categories/${slug}/products`,
  },

  search: "/search",
  reports: "/reports",
  home: "/home",
  countries: "/countries",
  languages: "/languages",
  currencies: "/currencies",
} as const;